import { MonetaryAmountWidget } from '../Widget';
import { UseAnnualIncomeWidgetArgs, useAnnualIncomeWidget } from './hooks';
import { Link } from '@remix-run/react';

interface AnnualIncomeWidgetProps extends UseAnnualIncomeWidgetArgs {
  title?: string | null;
  onClick?: () => void;
  linkTo?: string;
}

export function AnnualIncomeWidget(props: AnnualIncomeWidgetProps) {
  const { isLoading, annualIncome, tCommon } = useAnnualIncomeWidget(props);

  const Widget = () => {
    return (
      <MonetaryAmountWidget
        title={props.title ?? tCommon('annual-income-button-title')}
        isLoading={isLoading}
        suffix='/yr'
        monetaryAmount={annualIncome}
        onClick={props.onClick}
        withChevron={!!props.linkTo || !!props.onClick}
      />
    );
  };

  return props.linkTo ? (
    <Link to={props.linkTo} state={{ viewIndex: 0 }}>
      <Widget />
    </Link>
  ) : (
    <Widget />
  );
}
